<!-- 下发计算系数接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KM43Y46",
                "serialNumber": "20160723162730110",
                "carCode": "粤YAL888",
                "autoCouponValue": "0",
                "channelEventCode": "89783",
				"startTime": "2017-01-01 00:00:00",
				"endTime": "2017-01-01 12:00:00",
				"operateTime": "2017-01-01 00:00:00",
                "operator": "admin"
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台下发某个车辆的停车费计算系数",
                t_url: this.commonUrls.test+"syncAutoCoupon",
                p_url: this.commonUrls.prod+"syncAutoCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'serialNumber', info2: '是', info3: 'String', info4: '序列号，保证唯一' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'autoCouponValue', info2: '否', info3: 'String', info4: '券面值，免费券默认0；金额扣减券，2位小数；金额折扣券，2位小数；金额固定券，2位小数；时间券，为大于0的整数）金额相关的券都以元为单位，时间券以分为单位' },
                        { info1: 'channelEventCode', info2: '是', info3: 'String', info4: '通道事件编码，由VEMS提供' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '券有效开始时间,yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '券有效结束时间,yyyy-MM-dd HH:mm:ss' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间,yyyy-MM-dd HH:mm:ss' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作人' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/syncAutoCoupon.vue